import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAgent: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="agent, flow, diagram, org"><circle cx="12" cy="6" r="2.75" stroke="currentColor" strokeWidth="1.5"/><circle cx="6" cy="18" r="2.75" stroke="currentColor" strokeWidth="1.5"/><circle cx="18" cy="18" r="2.75" stroke="currentColor" strokeWidth="1.5"/><path d="M12 9V12M12 12H6V15M12 12H18V15" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconAgent;
